module.exports = __webpack_public_path__ + "static/media/tenor.33327eab.gif";